/**
 * Kalendertag in der Zeitzone Europe/Berlin als "YYYY-MM-DD".
 * Grundlage für das Tageslimit (max. 5 Verkostungen pro Tester und Kalendertag).
 */
export function kalendertagBerlin(date: Date = new Date()): string {
  // en-CA liefert das Format YYYY-MM-DD
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}
